var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-entry font-list-settings"},[_c('b',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._l((_vm.sortedFonts),function(name){return _c('SettingsFont',{key:name,attrs:{"name":name},on:{"deleted":function($event){return _vm.$emit('deleted', name)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }